module.exports = __webpack_public_path__ + "img/button_gallery_on.2b6c7d54.png";